import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('@/views/Home.vue'),
        meta: {
            // Het dashboard is publiek bereikbaar via "Bekijk diensten" op de
            // welkomstpagina; het mobiliteitsportaal blijft achter de login.
            requires_auth: false,
        },
    },
    {
        path: '/account',
        name: 'Account',
        component: () => import(/* webpackChunkName: "account" */ '@/views/Account.vue'),
    },
    {
        path: '/profielen',
        name: 'Profiles',
        component: () => import(/* webpackChunkName: "profile" */ '@/views/Profiles.vue'),
    },
    {
        path: '/profielen/:uuid',
        name: 'Profile',
        component: () => import(/* webpackChunkName: "profile" */ '@/views/Profile.vue'),
        props: true,
    },
    {
        path: '/dienstverleners',
        name: 'Organisations',
        component: () => import(/* webpackChunkName: "profile" */ '@/views/Organisations.vue'),
        meta: {
            // Dienstverleners zijn publiek raadpleegbaar zonder login.
            requires_auth: false,
        },
    },
    {
        path: '/dienstverleners/:uuid',
        name: 'Organisation',
        component: () => import(/* webpackChunkName: "profile" */ '@/views/Organisation.vue'),
        props: true,
        meta: {
            // Dienstverlener-detail is publiek raadpleegbaar zonder login.
            requires_auth: false,
        },
    },
    {
        // Aanvraagformulier vanaf de dienst-detailpagina.
        path: '/diensten/:uuid/aanvragen',
        name: 'RequestForm',
        component: () => import(/* webpackChunkName: "request" */ '@/views/services/RequestForm.vue'),
        props: true,
        meta: {
            requires_auth: false,
        },
    },
    {
        // HR beoordeelt de aanvraag via een magic link.
        path: '/aanvraag/beoordelen/:token',
        name: 'ReviewRequest',
        component: () => import(/* webpackChunkName: "request" */ '@/views/services/ReviewRequest.vue'),
        props: true,
        meta: {
            requires_auth: false,
            show_navigation: false,
        },
    },
    {
        // De aanvrager verstuurt de goedgekeurde aanvraag via een magic link.
        path: '/aanvraag/versturen/:token',
        name: 'SubmitRequest',
        component: () => import(/* webpackChunkName: "request" */ '@/views/services/SubmitRequest.vue'),
        props: true,
        meta: {
            requires_auth: false,
            show_navigation: false,
        },
    },
    {
        // De dienstverlener geeft de verwachte datums door via een magic link.
        path: '/aanvraag/datums/:token',
        name: 'ProvideDates',
        component: () => import(/* webpackChunkName: "request" */ '@/views/services/ProvideDates.vue'),
        props: true,
        meta: {
            requires_auth: false,
            show_navigation: false,
        },
    },
    {
        // De aanvrager vult de evaluatie in via een magic link, een week na de einddatum.
        path: '/aanvraag/evalueren/:token',
        name: 'EvaluateRequest',
        component: () => import(/* webpackChunkName: "request" */ '@/views/services/EvaluateRequest.vue'),
        props: true,
        meta: {
            requires_auth: false,
            show_navigation: false,
        },
    },
    {
        // Welkomstpagina met de publieke ingangen; het inlogformulier staat op /inloggen.
        path: '/login',
        name: 'Login',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/Login.vue'),
        meta: {
            requires_auth: false,
            show_navigation: false,
        },
    },
    {
        path: '/inloggen',
        name: 'SignIn',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/SignIn.vue'),
        meta: {
            requires_auth: false,
            show_back_button: true,
            show_navigation: false,
        },
    },
    {
        path: '/wachtwoord-vergeten',
        name: 'ForgotPassword',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/ForgotPassword.vue'),
        meta: {
            requires_auth: false,
            show_back_button: true,
            show_navigation: false,
        },
    },
    {
        path: '/wachtwoord-reset/:token',
        name: 'ResetPassword',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/ResetPassword.vue'),
        meta: {
            requires_auth: false,
            show_navigation: false,
        },
    },
    {
        path: '/profiel-insturen',
        name: 'RegisterProfile',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/RegisterProfile.vue'),
        meta: {
            requires_auth: false,
            show_back_button: false,
            show_navigation: false,
        },
    },
    {
        path: '/profiel-insturen/bedankt',
        name: 'RegisterSuccess',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/RegisterSuccess.vue'),
        meta: {
            requires_auth: false,
            show_back_button: true,
            show_navigation: false,
        },
    },
    {
        path: '/profiel-insturen/:uuid/afmelden',
        name: 'ProfileRegisterSignOut',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/ProfileSignOut.vue'),
        meta: {
            requires_auth: false,
            show_back_button: false,
            show_navigation: false,
        },
    },
    {
        path: '/organisatie-insturen',
        name: 'RegisterOrganisation',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/RegisterOrganisation.vue'),
        meta: {
            requires_auth: false,
            show_back_button: false,
            show_navigation: false,
        },
    },
    {
        path: '/organisatie-insturen/bedankt',
        name: 'RegisterSuccessOrganisation',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/RegisterSuccessOrganisation.vue'),
        meta: {
            requires_auth: false,
            show_back_button: true,
            show_navigation: false,
        },
    },
    {
        path: '/organisation-insturen/:uuid/afmelden',
        name: 'OrganisationSignOut',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/OrganisationSignOut.vue'),
        meta: {
            requires_auth: false,
            show_back_button: false,
            show_navigation: false,
        },
    },
    {
        path: '/school-registreren/:id/afmelden',
        name: 'RegisterSignOut',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/RegisterSignOut.vue'),
        meta: {
            requires_auth: false,
            show_back_button: false,
            show_navigation: false,
        },
    },
    {
        path: '/school-registreren',
        name: 'RegisterSchool',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/RegisterSchool.vue'),
        meta: {
            requires_auth: false,
            show_back_button: true,
            show_navigation: false,
        },
    },
    {
        path: '/:catchAll(.*)',
        name: 'NotFound',
        component: () => import(/* webpackChunkName: "error" */ '@/views/NotFound.vue'),
        meta: {
            show_navigation: false,
            requires_auth: false,
        },
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior (to, from, savedPosition) {
        if (to && from && to.name === from.name) {
            return savedPosition;
        }

        return { x: 0, y: 0 };
    },
    routes
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requires_auth === 'undefined' || record.meta.requires_auth !== false)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (!store.state.auth.isLoggedIn) {
            next({
                name: 'Login'
            })
        } else {
            next()
        }
    } else {
        next()
    }
})


export default router
